import script from "./PageProductCollections.vue?vue&type=script&setup=true&lang=js"
export * from "./PageProductCollections.vue?vue&type=script&setup=true&lang=js"

import "./PageProductCollections.vue?vue&type=style&index=0&id=37cb2d1d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37cb2d1d"]])

export default __exports__